import React, { FC, useContext, useEffect, useRef, useState } from "react";
import "./NetworkSettings.scss";
import { ReactComponent as UserIcon } from "../../../assets/userHeader.svg";
import { useNavigate } from "react-router";
import clubAvatar from "../../../assets/userImagePlaceholder.png";
import {
  DASHBOARD,
  USER_ACCOUNT_SETTINGS,
} from "../../../common/constants/routes.constants";
import { UserContext } from "../../../contexts/userContext";
import { EMPTY_STRING } from "../../../common/constants/common.constants";
import { ClubAppNetwork } from "../../../common/enums/common.enums";

const NetworkSettings: FC<{ closeSideBar: () => void }> = ({
  closeSideBar,
}) => {
  const navigate = useNavigate();

  const { user } = useContext(UserContext);

  const [isSettingsOpen, toggleIsSettingsOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    document.addEventListener("mousedown", checkIfClickedOutside);
    return () => {
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [isSettingsOpen]);

  const checkIfClickedOutside = (e) => {
    if (isSettingsOpen && ref.current && !ref.current.contains(e.target)) {
      toggleIsSettingsOpen(false);
    }
  };

  return (
    <div className="network-settings">
      <img
        className="network-settings__profile-image"
        src={
          user && user?.imageUrl && user?.imageUrl !== EMPTY_STRING
            ? user.imageUrl
            : '/logo-3.svg'
        }
        alt=""
        onClick={() => toggleIsSettingsOpen(true)}
      />
      <div
        ref={ref}
        className={`network-settings__modal ${
          isSettingsOpen && "network-settings__modal--active"
        }`}
      >
        <div
          className="network-settings__menu-item"
          onClick={() => {
            navigate(`${DASHBOARD + USER_ACCOUNT_SETTINGS}`);
            toggleIsSettingsOpen(false);
            closeSideBar();
          }}
        >
          <UserIcon className="network-settings__user-icon" />
          <p className="network-settings__menu-item-name">Account settings</p>
        </div>
        <div
          className="network-settings__menu-item"
          onClick={() => {
            navigate(EMPTY_STRING);
            toggleIsSettingsOpen(false);
            closeSideBar();
          }}
        >
          <a
            className="network-settings__network-wrapper"
            target="_blank"
            rel="noreferrer"
            href={ClubAppNetwork.MAINNET}
          >
            <div className="network-settings__network network-settings__network--active"></div>
            <p className="network-settings__name network-settings__name--active">
              Mainnet
            </p>
          </a>
          <a
            className="network-settings__network-wrapper"
            target="_blank"
            rel="noreferrer"
            href={ClubAppNetwork.DEVNET}
          >
            <div className="network-settings__network"></div>
            <p className="network-settings__name">Devnet</p>
          </a>
        </div>
      </div>
    </div>
  );
};

export default NetworkSettings;
